// bootstraps the react application
import React from 'react';

import App from './App';

import { createRoot } from 'react-dom/client';

// Self-hosted fonts (no Google Fonts requests). Imported here, not via Sass @import, which is deprecated.
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './index.scss';

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);
root.render(<App />);